var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex__right mb-15"},[_c('download-excel',{staticClass:"mt-15 btn btn__sm btn__frost",attrs:{"data":_vm.productsData,"name":"product-data.csv","type":"csv"}},[_vm._v("Export")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }